import { apolloClient } from "@/apollo/index";

import updateCampaignMutation from "@/apollo/mutations/UpdateCampaign.gql";
import campaignEditorQuery from "@/apollo/queries/v2/CampaignEditor.gql";
import type { LanguageCode } from "@/utils/languages";
import type { Campaign } from "shared-types";

export async function updateLanguages(campaignId: string, languages: LanguageCode[]) {
    const { data, errors } = await apolloClient.mutate<{
        updateCampaign: Campaign;
    }>({
        mutation: updateCampaignMutation,
        variables: {
            campaignId,
            campaign: {
                languages
            }
        },
        refetchQueries: [
            {
                query: campaignEditorQuery,
                variables: { campaignId }
            }
        ]
    });

    if (errors?.length) {
        throw new Error(errors.map(e => e.message).join(", "));
    }

    if (!data?.updateCampaign) {
        throw new Error(`Failed to update languages. Please try again.`);
    }
}
